var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Qtxzgl_detailed),
      expression: "Qtxzgl_detailed"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("其他险种管理-明细")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.condition.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.condition, "organize_ids", $$v)
      },
      expression: "condition.organize_ids"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("唯一识别码 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "170px"
    },
    attrs: {
      "placeholder": "请输入唯一识别码"
    },
    model: {
      value: (_vm.condition.unique_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "unique_id", $$v)
      },
      expression: "condition.unique_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("名称/品牌 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "170px"
    },
    attrs: {
      "placeholder": "请输入名称/品牌"
    },
    model: {
      value: (_vm.condition.brand),
      callback: function($$v) {
        _vm.$set(_vm.condition, "brand", $$v)
      },
      expression: "condition.brand"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("缴纳状态 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "170px"
    },
    attrs: {
      "placeholder": "请选择缴纳状态",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.spare5),
      callback: function($$v) {
        _vm.$set(_vm.condition, "spare5", $$v)
      },
      expression: "condition.spare5"
    }
  }, _vm._l((_vm.jnList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("导表状态 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "170px"
    },
    attrs: {
      "placeholder": "请选择导表状态",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.spare6),
      callback: function($$v) {
        _vm.$set(_vm.condition, "spare6", $$v)
      },
      expression: "condition.spare6"
    }
  }, _vm._l((_vm.dbList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("导表")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Del()
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("缴纳")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.add('ruleForm')
      }
    }
  }, [_vm._v("新增")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2% 3% 0 3%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "540"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organize_name",
      "align": "center",
      "label": "所属项目"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_id",
      "align": "center",
      "label": "唯一识别码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "insure_number",
      "align": "center",
      "label": "投保数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brand",
      "align": "center",
      "label": "名称/品牌"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "model",
      "align": "center",
      "label": "规格/型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "align": "center",
      "label": "费用金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "缴纳状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.spare5 === '0'),
            expression: "scope.row.spare5 === '0'"
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_未缴纳.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.spare5 === '1'),
            expression: "scope.row.spare5 === '1'"
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_已缴纳.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.spare5 === '2'),
            expression: "scope.row.spare5 === '2'"
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_未退保.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.spare5 === '3'),
            expression: "scope.row.spare5 === '3'"
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_已退保.png")
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "导表状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.spare6 === '0'),
            expression: "scope.row.spare6 === '0'"
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_未导表.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.spare6 === '1'),
            expression: "scope.row.spare6 === '1'"
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_已导表.png")
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/编辑.png")
          },
          on: {
            "click": function($event) {
              return _vm.bianji(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/删除.png")
          },
          on: {
            "click": function($event) {
              return _vm.Del(scope.row.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('add', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showadd),
      expression: "showadd"
    }],
    ref: "adds",
    attrs: {
      "organizeList": _vm.organizeList
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a6c9b12","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/QtxzGl/Qtxzgl_detailed.vue
// module id = null
// module chunks = 